import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'smpw.recentLocations';
const MAX_RECENTS = 10;

const safeRead = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((s) => typeof s === 'string' && s.trim() !== '');
  } catch {
    return [];
  }
};

const safeWrite = (list) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    // Ignore storage errors (quota exceeded, private mode, etc.)
  }
};

export function useRecentLocations() {
  const [recents, setRecents] = useState(safeRead);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === STORAGE_KEY) setRecents(safeRead());
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  const addRecent = useCallback((rawName) => {
    const name = (rawName || '').trim();
    if (!name) return;
    setRecents((prev) => {
      const filtered = prev.filter((n) => n.toLowerCase() !== name.toLowerCase());
      const next = [name, ...filtered].slice(0, MAX_RECENTS);
      safeWrite(next);
      return next;
    });
  }, []);

  const removeRecent = useCallback((rawName) => {
    const name = (rawName || '').trim();
    if (!name) return;
    setRecents((prev) => {
      const next = prev.filter((n) => n.toLowerCase() !== name.toLowerCase());
      safeWrite(next);
      return next;
    });
  }, []);

  return { recents, addRecent, removeRecent };
}
